


































































import { Watch, Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import OrganizationModel from "@/model/Organization";
import OrganizationApi from "@/api/Organization";
import InputControl from "@/components/Controls/InputControl.vue";
import TextareaControl from "@/components/Controls/TextareaControl.vue";
import CurrencyControl from "@/components/Controls/CurrencyControl.vue";
import DateControl from "@/components/Controls/DateControl.vue";
import BaseForm from "@/components/Base/Form/BaseForm.vue";
import validations from "./validations";
import ModelFactory from "@/model/ModelFactory";

const AppStore = namespace("App");

@Component({
  name: "OrganizationEdit",
  components: {
    InputControl,
    TextareaControl,
    CurrencyControl,
    DateControl
  },
  validations
})
export default class OrganizationEdit extends BaseForm {
  @Prop({ required: true })
  readonly value!: OrganizationModel;

  @Prop({ required: true, default: false })
  public show!: boolean;

  public organization: OrganizationModel = ModelFactory.create(
    "OrganizationModel"
  );
  public formName: string = "organization";
  public formUrl: string = OrganizationApi.getOrganizationUrl();
  public saving: boolean = false;

  @AppStore.State
  public reportYear!: number;

  get minDate(): string {
    return `${this.reportYear}-01-01`;
  }

  get maxDate(): string {
    return `${this.reportYear}-12-31`;
  }

  get title() {
    return (this as any).organization.id > 0
      ? "Edycja organizacji"
      : "Nowa organizacja";
  }

  @Watch("organization.id")
  setformUrl(newValue: number) {
    this.formUrl = OrganizationApi.getOrganizationUrl(newValue);
  }

  @Watch("value")
  setOrganization() {
    this.organization = this.value;
  }

  @Watch("show")
  setShow(newValue: boolean) {
    if (newValue) {
      this.reset();
    }
  }

  touch(validator: any) {
    if (validator) {
      validator.$touch();
    }
  }

  close(bvModalEvt?: any) {
    if (this.isSending) {
      bvModalEvt.preventDefault();
      return;
    }

    this.reset();
    this.$emit("hide", this.organization);
  }

  save(bvModalEvt: any) {
    this.submit();
    bvModalEvt.preventDefault();
  }

  afterSubmit(res: any) {
    if (res && res.data?.success) {
      this.$emit("save", res.data.object);
      this.close();
    }
  }
}
